module.exports = __webpack_public_path__ + "static/media/thumb_down_outline.7a50eb02.png";